export default __webpack_public_path__ + "static/media/photo--sm--workshop.a181a27a.jpg";